import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import SpaceFlightService from "../../../../services/reservations/SpaceFlightService";

export const REQUEST_CREATE_SPACE_FLIGHT = "REQUEST_CREATE_SPACE_FLIGHT";
export const CREATE_SPACE_FLIGHT_SUCCESS = "CREATE_SPACE_FLIGHT_SUCCESS";
export const CREATE_SPACE_FLIGHT_ERROR = "CREATE_SPACE_FLIGHT_ERROR";

function requestCreateSpaceFlight() {
  return {
    type: REQUEST_CREATE_SPACE_FLIGHT,
  };
}

function createSpaceFlightSuccess(json) {
  return {
    type: CREATE_SPACE_FLIGHT_SUCCESS,
    message: json.data,
  };
}

function createSpaceFlightError(json) {
  return {
    type: CREATE_SPACE_FLIGHT_ERROR,
    error: json.data,
  };
}

export function createSpaceFlight(space_id, payload) {
  return (dispatch) => {
    dispatch(requestCreateSpaceFlight());
    return SpaceFlightService.postSpaceFlight(space_id, payload).then(
      (json) => {
        if (json.data.code === 200) {
          dispatch(createSpaceFlightSuccess(json.data));
        } else if (json.data.code === 202) {
          updateLocalStorageToken(json.data.token);
          dispatch(createSpaceFlight(space_id, payload));
        } else if (json.data.code === 498) {
          logOut();
        } else {
          dispatch(createSpaceFlightError(json.data));
        }
      }
    );
  };
}
